<template>
  <section class="bg-gradient-to-b from-blue-400/10 to-[#39C3FF]/10 py-12">
    <div class="container-wrap">
      <p v-if="contextData.sectionName" class="text-sm font-bold text-gray-600">
        {{ contextData.sectionName }}
      </p>
      <h2 class="text-h2 mb-6 text-blue-400 tablet:line-clamp-2">
        {{ contextData.title }}
      </h2>
      <p class="mb-6 text-sm text-gray-600 tablet:text-base">
        {{ contextData.description }}
      </p>
    </div>
  </section>
</template>

<script setup lang="ts">
  import type { ISuiteProps } from '@/components/Shared/Suite/type.ts';

  interface IStageData {
    sectionName?: string;
    title: string;
    description: string;
  }

  interface IStage {
    component: 'topics-stage';
    meta: {
      navigable?: string;
    };
    data: IStageData;
  }

  type IProps = ISuiteProps<IStage>;

  const props = defineProps<IProps>();

  const contextData = computed((): IStageData => props.suiteData.data);

  export type { IStage, IStageData };
</script>
